import FormCreateShuma from './FormCreateShuma';

export default FormCreateShuma;
